// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7d43ebe2","732":"8b467fc3","977":"7b3f2c8c"}[chunkId] + ".chunk.js";
};